import * as _ from "lodash";

export class ConsentType {
    public id?: any;
    public name?: any;
    public status?: any;
    public timestamp?: any;
    public creationtimestamp?: any;

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        } else {
            this.id = null;
            this.name = null;
            this.status = null;
            this.timestamp = null;
            this.creationtimestamp = null;
        }
    }

    setData(data: any): void {
        _.merge(this, data);
    }
}
